<template>
  <div class="ap-field">
    <label>{{ label }} <span v-if="required" class="ap-req">*</span></label>
    <div class="ap-input-wrap">
      <fa-icon :icon="['fas', 'calendar-alt']" class="ap-lead" />
      <input
        :value="value"
        type="text"
        placeholder="DD/MM/YYYY"
        class="ap-input"
        :class="{ 'has-error': value && !isValid }"
        maxlength="10"
        @input="handleInput"
      />
    </div>
    <span v-if="value && !isValid" class="ap-err">
      <fa-icon :icon="['fas', 'exclamation-circle']" /> Use DD/MM/YYYY format.
    </span>
    <span v-if="showHint" class="ap-hint">Format: 31/12/1989</span>
  </div>
</template>

<script>
export default {
  name: 'DobInput',
  props: {
    value: { type: String, default: '' },
    label: { type: String, default: 'Date of birth' },
    required: { type: Boolean, default: false },
    showHint: { type: Boolean, default: false }
  },
  computed: {
    isValid () {
      const match = (this.value || '').match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
      if (!match) return false
      const [, dd, mm, yyyy] = match
      const d = new Date(+yyyy, +mm - 1, +dd)
      return d.getFullYear() === +yyyy && d.getMonth() === +mm - 1 && d.getDate() === +dd
    }
  },
  methods: {
    handleInput (e) {
      let v = e.target.value.replace(/[^0-9/]/g, '')
      if (v.length > 2 && v[2] !== '/') v = v.slice(0, 2) + '/' + v.slice(2)
      if (v.length > 5 && v[5] !== '/') v = v.slice(0, 5) + '/' + v.slice(5)
      this.$emit('input', v.slice(0, 10))
    }
  }
}
</script>
